<template>
<Head>
    <title>Wakaf Pahang - Wakaf dalam talian</title>
    <link rel="preload" fetchpriority="high" as="image" :href="img_wakafpahang" type="image/webp">
    <link rel="shortcut apple-touch-icon icon" as="image" :href="img_favicon" type="image/png">
</Head>

<div class="min-vh-100 py-3 py-md-4 d-flex align-items-center justify-content-center">
    <form method="post" class="w-100" @submit.prevent="submitForm">
        <section class="container px-3 px-md-4">
            <div class="row justify-content-center mb-3">
                <div class="col-lg-12">
                    <div class="alert alert-info border-info border-opacity-50 d-flex align-items-center p-2 p-md-3 rounded-3 rounded-md-4 shadow-sm mb-0" style="background-color: #e8f4fd;">
                        <img :src="ezid_logo" height="16" width="16" alt="Logo Ezid" class="me-2" decoding="async">
                        <span class="fw-medium text-dark" style="font-size: 0.8rem;">Pembayaran ini dibuat melalui akaun e-Zid — <strong>{{ info.nama }}</strong></span>
                    </div>
                </div>
            </div>
            <div class="row g-3 justify-content-center">
                <div class="col-12 col-lg-7 order-1 order-lg-1">
                    <div class="card border-0 shadow-sm rounded-3 rounded-md-4 p-3 p-md-4 bg-white">
                        <div class="d-flex flex-column flex-sm-row justify-content-center justify-content-sm-between align-items-center align-items-sm-center border-bottom pb-3 mb-3">
                            <div class="mb-2 mb-sm-0 text-center text-sm-start">
                                <img :src="img_wakafpahang" decoding="async" alt="Wakaf Pahang" class="img-fluid" style="height: 45px; width: 220px;">
                            </div>
                            <div class="text-center text-sm-end">
                                <h1 class="fs-6 fw-bold mb-0 text-dark">Sistem Pembayaran Wakaf Pahang</h1>
                                <p class="text-muted mb-0" style="font-size: 0.75rem;">info@wakafpahang.my | 09-514-5151</p>
                            </div>
                        </div>
                        <h2 class="fs-6 fw-bold mb-3 d-flex align-items-center gap-2">Maklumat Pewakaf</h2>
                        <div class="row g-2">
                            <div class="col-12">
                                <label class="form-label fw-medium small text-dark mb-1">Nama</label>
                                <input :value="info.nama" type="text" class="form-control rounded-3 py-2" readonly disabled>
                            </div>
                            <div class="col-md-6">
                                <label class="form-label fw-medium small text-dark mb-1">No. Kad Pengenalan Diri</label>
                                <input :value="info.nokp" type="text" class="form-control rounded-3 py-2" readonly disabled>
                            </div>
                            <div class="col-md-6">
                                <label class="form-label fw-medium small text-dark mb-1">No. Telefon Bimbit</label>
                                <input :value="info.telefonbimbit" type="text" class="form-control rounded-3 py-2" readonly disabled>
                            </div>
                            <div class="col-md-6">
                                <label class="form-label fw-medium small text-dark mb-1">E-mel</label>
                                <input :value="info.emel" type="email" class="form-control rounded-3 py-2" readonly disabled>
                            </div>
                            <div class="col-md-6">
                                <label class="form-label fw-medium small text-dark mb-1">Daerah Pewakaf</label>
                                <input :value="info.daerah" type="text" class="form-control rounded-3 py-2" readonly disabled>
                            </div>
                        </div>
                        <div class="mt-3 pt-3 border-top text-center">
                            <p class="fw-bold text-secondary mb-1" style="font-size: 0.8rem;">Hakcipta Terpelihara &copy; {{ currentYear }} Pusat Kutipan Zakat dan Wakaf Pahang</p>
                            <p class="text-muted mb-0" style="font-size: 0.75rem;">Pembayaran selamat melalui FPX (Perbankan Internet). Semai di dunia, tuai di akhirat.</p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-5 order-2 order-lg-2">
                    <div class="card border-0 shadow-sm rounded-3 rounded-md-4 p-3 sticky-lg-top bg-white" style="top: 16px;">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <h2 class="fs-6 fw-bold mb-0 d-flex align-items-center gap-2">Senarai Wakaf</h2>
                            <button class="btn btn-primary btn-sm rounded-3 fw-medium d-flex align-items-center gap-1 shadow-sm" type="button" @click="wakafDataRef?.openAddModal()">
                                <span class="fw-bold">+</span> Tambah
                            </button>
                        </div>
                        <transaction-public ref="wakafDataRef" :wakaf_type='wakaf_type' :wakaf_district='wakaf_district' :wakaf_project='wakaf_project'
                                    :nama_pewakaf="info.nama" :w_id="data.wid" :d_id="data.did" :p_id="data.pid"
                                    @calulate-sum="calculateSum" :userdata='userdata'></transaction-public>
                        <div class="bg-light border rounded-3 p-2 mt-3">
                            <p class="mb-1 text-muted" style="font-size: 0.75rem;">Boleh tambah sehingga 10 maklumat wakaf.</p>
                            <p class="mb-0 text-muted" style="font-size: 0.75rem;">Caj transaksi FPX sebanyak RM 0.50 akan dikenakan.</p>
                        </div>
                        <div v-if="isDisplayGrandSumAndSubmit" class="d-flex justify-content-between align-items-center mt-3 mb-3 p-3 rounded-3 bg-amount">
                            <span class="fw-medium small text-dark">Jumlah Keseluruhan</span>
                            <span class="fs-4 fw-bold text-amount">{{ sumFormat(sum) }}</span>
                        </div>
                        <div v-else class="mt-3 mb-3 pb-2 border-bottom text-muted" style="font-size: 0.85rem;">
                            Tambah maklumat wakaf untuk melihat jumlah bayaran.
                        </div>
                        <div class="d-flex gap-2">
                            <button v-if="!hideCloseBtn" class="btn btn-outline-danger py-2 rounded-3 fw-bold shadow-sm d-flex justify-content-center align-items-center gap-2"
                                    @click="cancelFormSubmit" type="button">
                                <font-awesome-icon :icon="faXmark" /> Batal
                            </button>
                            <button v-if="isDisplayGrandSumAndSubmit" class="btn bg-brand w-100 py-2 rounded-3 fw-bold shadow-sm d-flex justify-content-center align-items-center gap-2" type="submit">
                                Teruskan Pembayaran
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </form>
</div>
</template>

<script setup lang="ts">
import {Head} from "@inertiajs/vue3";
import {sumFormat} from "../../utils/utils"
import {onMounted, Ref, ref} from "vue";
import axios from "axios";
import Swal from "sweetalert2";
import transactionPublic from "./transactionPublic.vue";
import {faPaperPlane, faXmark} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import type {FormGeneral} from "../interface/FormGeneral";
library.add(faPaperPlane, faXmark);

const data = defineProps<{
    currentYear: number,
    img_fpx: string,
    img_wakafpahang: string,
    img_favicon: string,
    img_wakafconfrim: string,
    csrf: string,
    submit_url: string,
    ezid_logo: string,
    info: {
        nama: string,
        telefonbimbit: string,
        daerah: string,
        nokp: string,
        emel: string
    },
    district: [{
        KodDaerah: number,
        Daerah: string,
    }],
    wakaf_type: [{
        id: number,
        Nama: string,
    }],
    wakaf_district: [{
        KodDaerah: number,
        WakafJenisID: number,
        daerah: string,
    }],
    wakaf_project: [{
        kod: number,
        nama: string,
        WakafJenisID: number,
        DaerahID: number,
    }],
    wid?: number,
    did?: number,
    pid?: number | string, // due to HBHD and gabby
    userdata?: [{
        ID: number,
        JenisWakaf: number,
        KodDaerah: number,
        Projek: number,
        Unit: number,
        JenisPemilikan: string,
        NamaPemilik: string,
        Amaun: number,
        NoResitt: number,
        WakafResitID: number
    }],
}>();

const sum: Ref = ref<number>();
const hideCloseBtn: Ref = ref<boolean>(true);
const wakafDataRef: Ref = ref<InstanceType<typeof transactionPublic> | null>(null);
const isDisplayGrandSumAndSubmit: Ref = ref<boolean>(false);

const submitForm = (): void => {
    Swal.fire({
        title: "Anda pasti untuk hantar?",
        html: `<p class="fs-6">Saya dengan ini mewakafkan nilai sebanyak <b> ${sumFormat(sum.value)}</b> selama-lamanya kerana Allah Ta'ala</p>
                    <p style="font-size: 12px" class="fst-italic">Tiada caj pengurusan akan diambil terhadap amaun wakaf. Pihak pengurusan hanya diizinkan mengambil caj pengurusan daripada hibah / keuntungan deposit wang wakaf (jika ada) pada kadar tidak melebihi separuh amaun hibah / keuntungan deposit.</p>
                   `,
        imageUrl: data.img_wakafconfrim,
        imageWidth: 128,
        imageHeight: 128,
        imageAlt: "https://scontent.fkul8-1.fna.fbcdn.net/v/t39.30808-6/273934690_502048671273505_7724223417660615651_n.jpg?_nc_cat=108&ccb=1-7&_nc_sid=09cbfe&_nc_ohc=qovDre6CzQAAX9lAgpE&_nc_ht=scontent.fkul8-1.fna&oh=00_AT9duT49qOrl9u0V5fVc3mFTWd8j4O6WYi2w-FM0LJQ7eA&oe=63424A82",
        showConfirmButton: true,
        confirmButtonColor: "#198754",
        confirmButtonText: "Ya, saya wakafkan",
        showCancelButton: true,
        cancelButtonText: "Kembali",
        cancelButtonColor: "#0d6efd",
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
        reverseButtons: true,
        preConfirm: () => {
            // return 0
            let jenisWakaff : number[] = [];
            let daerahWakaff : number[] = [];
            let projekWakaff : number[] = [];
            let unitt : number[] = [];
            let jumlahh : number[] = [];
            let jenisPemilikk : string[] = [];
            let namaPemilikk : string[] = [];
            wakafDataRef.value?.transactionPublic.forEach((item:FormGeneral) => {
                jenisWakaff.push(item.jenisWakaf);
                daerahWakaff.push(item.daerahWakaf);
                projekWakaff.push(item.projekWakaf);
                unitt.push(item.unit);
                jumlahh.push(item.jumlah);
                jenisPemilikk.push(item.jenisPemilik);
                namaPemilikk.push(item.namaPemilik);
            })
            return axios({
                method: "post",
                url: data.submit_url,
                data: {
                    csrf: data.csrf,
                    jenisWakaf: jenisWakaff,
                    daerahWakaf: daerahWakaff,
                    projekWakaf: projekWakaff,
                    unit: unitt,
                    jumlah: jumlahh,
                    jenisPemilik: jenisPemilikk,
                    namaPemilik: namaPemilikk,
                }
            }).then(function (response) {
                window.location.href = response.data;
            }).catch(function (error) {
                Swal.fire({
                    icon: "error",
                    title: "Ralat berlaku",
                    text: "Sila cuba semula untuk hantar. " + error.body.message,
                    timer: 5000,
                    timerProgressBar: true,
                    confirmButtonColor: "#0d6efd",
                    confirmButtonText: "Ok",
                })
            });


        },
    })

}
const calculateSum = (summ: number) : void =>{
    if(wakafDataRef.value.transactionPublic.length === 0) {
        isDisplayGrandSumAndSubmit.value = false;
        sum.value = 0;
    } else if (wakafDataRef.value.transactionPublic.length > 0) {
        isDisplayGrandSumAndSubmit.value = true;
        sum.value = summ;
    }
}

const cancelFormSubmit = () => {
    Swal.fire({
        position: "top",
        icon: "question",
        title: "Anda pasti untuk batal?",
        showConfirmButton: true,
        confirmButtonColor: "#dc3545",
        confirmButtonText: "Ya",
        showCancelButton: true,
        cancelButtonText: "Kembali",
        cancelButtonColor: "#0d6efd"
    }).then((result) => {
        if (result.isConfirmed) {
            window.close()
        }
    })
}
onMounted(() => {
    if (window.opener !== null) {
        hideCloseBtn.value = false;
    }
    wakafDataRef.value.openAddModal();
});
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

:global(body) {
    font-family: 'Inter', sans-serif;
    background-color: #f1f5f9;
}

.text-brand {
    color: #4b2045 !important;
}

.bg-brand {
    background-color: #4b2045 !important;
    color: white !important;
}

.bg-brand:hover {
    background-color: #3a1835 !important;
    color: white !important;
}

.bg-amount {
    background-color: #fef3e2;
    border: 1px solid #f59e0b;
}

.text-amount {
    color: #d97706;
}

.form-control:focus,
.form-select:focus {
    border-color: #4b2045;
    box-shadow: 0 0 0 0.25rem rgba(75, 32, 69, 0.15);
    background-color: #ffffff;
}

.form-control,
.form-select {
    background-color: #ffffff;
}

.form-control:disabled,
.form-control[readonly] {
    background-color: #fafafa;
}

@media (max-width: 575.98px) {
    .card {
        border-radius: 12px !important;
    }

    .form-control,
    .form-select {
        font-size: 16px;
        padding: 0.5rem 0.75rem;
    }

    .btn {
        font-size: 0.85rem;
    }
}

@media (min-width: 576px) and (max-width: 991.98px) {
    .card {
        border-radius: 16px !important;
    }
}

@media (min-width: 992px) {
    .sticky-lg-top {
        position: sticky;
        top: 16px;
    }
}
</style>
